<mat-card class="cardWithShadow theme-card">
    <mat-card-content class="b-t-1">
        <p>The API uses token-based authentication. You will be provided with a token & Secretkey which must be included
            in the header of all requests made to the API. All API requests must be made over HTTPS. Any requests made
            over HTTP will fail. You will be provided with both UAT and Production tokens. Requests made with the UAT
            token can be used to test our API before going live. Requests made in UAT mode will return actual responses
            and trial credits capped at 50 will be deducted from your account.</p>
        <div class="m-b-2">
            <h2 class="f-w-500">Errors and Status Codes</h2>
            <p>Standard HTTP error codes are returned in the case of a failure. 2xx codes indicate a successful message; 4xx
                codes indicate an error caused by the information provided by the client, and 5xx codes indicate an error.
            </p>
            <h3 class="f-w-500 m-b-0">STATUS CODE</h3>
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" class="w-100">
                    <!-- Profile Column -->
                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef class="f-w-500 mat-subtitle-1 f-s-16">
                            Status
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-body-1">
                            <span class="f-s-14">{{ element.status }}</span>
                        </td>
                    </ng-container>

                    <!-- Hour Rate Column -->
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef class="f-w-500 mat-subtitle-1 f-s-16">
                            Name
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-body-1">
                            <span class="f-s-14">{{ element.name }}</span>
                        </td>
                    </ng-container>

                    <!-- Symbol Column -->
                    <ng-container matColumnDef="meaning">
                        <th mat-header-cell *matHeaderCellDef class="f-w-500 mat-subtitle-1 f-s-16">
                            Meaning
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-body-1">
                            <span class="f-s-14">{{ element.meaning }}</span>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>
            </div>
            <h3 class="f-w-500 m-b-0">ERROR CODE</h3>
            <div class="table-responsive">
                <table mat-table [dataSource]="errordataSource" class="w-100">
                    <!-- Profile Column -->
                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef class="f-w-500 mat-subtitle-1 f-s-16">
                            Status
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-body-1">
                            <span class="f-s-14">{{ element.status }}</span>
                        </td>
                    </ng-container>

                    <!-- Hour Rate Column -->
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef class="f-w-500 mat-subtitle-1 f-s-16">
                            Name
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-body-1">
                            <span class="f-s-14">{{ element.name }}</span>
                        </td>
                    </ng-container>

                    <!-- Symbol Column -->
                    <ng-container matColumnDef="meaning">
                        <th mat-header-cell *matHeaderCellDef class="f-w-500 mat-subtitle-1 f-s-16">
                            Meaning
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-body-1">
                            <span class="f-s-14">{{ element.meaning }}</span>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>
            </div>
        </div>
        <!-- <div class="m-b-2">
            <h2>Rate Limits</h2>
            <p>
                Estater API enforces a maximum volume of requests per minute for all clients. Unless contractually agreed otherwise, the maximum rate is 100 requests per minute. Any request over the limit will return a 429 HTTP response.
            </p>
        </div> -->
    </mat-card-content>
</mat-card>